import {Vue, Component, Prop} from 'vue-property-decorator';
import Header from "@/app/shared/components/header/Header.vue";
import LoginPopup from "@/app/shared/components/login-popup/login-popup.component.vue";
import Footer from "@/app/shared/components/footer/Footer.vue";
import store from './store';
import {AffiliateConfigurationService} from "@/app/services/affiliate-configuration.service";

@Component<App>({
    components: ({
        Header,
        LoginPopup,
        Footer
    })
})
export default class App extends Vue {
    private readonly affiliateConfigurationService = new AffiliateConfigurationService();
    private affiliateConfiguration: any = {};
    public store = store;

    public constructor() {
        super();
        //this.indieLogin = new IndieLogin();
        store.dispatch("initIndieLogin").then(() => {

        });
    }

    public mounted() {
        return true;
    }

    public created() {
        return true;
    }

    public destroyed() {
        return true;
    }

    public updated() {
        return true;
    }
}
